export enum NotificationsNames {
  UserPermissionsChanged = 'PermissionManagement.UserPermissionsChanged',
  UserNotificationCreated = 'UserNotifications.UserNotificationCreated',
  UserNotificationMarkedAsRead = 'UserNotifications.NotificationMarkedAsRead',
  UserNotificationMarkedAsUnread = 'UserNotifications.NotificationMarkedAsUnread',
  UserNotificationsMarkedAsRead = 'UserNotifications.AllNotificationsMarkedAsRead',
}
